import { render } from "./talk-settings.vue?vue&type=template&id=8c61c06e&scoped=true"
import script from "./talk-settings.vue?vue&type=script&lang=js"
export * from "./talk-settings.vue?vue&type=script&lang=js"

import "./talk-settings.vue?vue&type=style&index=0&id=8c61c06e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c61c06e"]])

export default __exports__